import React from 'react';
import { Calendar, CalendarCheck, Clock } from 'lucide-react';
import MetricsGrid from '@components/common/MetricsGrid';
import MetricCard from '@components/common/MetricCard';

interface SchedulerMetricsData {
  readyForScheduling: number;
  scheduled: number;
  pendingInvitations: number;
  byStatus: Array<{ status: string; count: number }>;
}

interface SchedulerMetricsProps {
  data: SchedulerMetricsData;
  isLoading: boolean;
}

// Scheduler metrics show data for the CURRENT USER only
const SchedulerMetrics: React.FC<SchedulerMetricsProps> = ({ data, isLoading }) => {
  const metrics = [
    {
      label: 'Ready for Scheduling',
      value: data.readyForScheduling,
      icon: Calendar,
      variant: 'blue' as const,
      subtitle: 'Your contracts awaiting schedule'
    },
    {
      label: 'Scheduled Meetings',
      value: data.scheduled,
      icon: CalendarCheck,
      variant: 'orange' as const,
      subtitle: 'Your meetings arranged'
    },
    {
      label: 'Pending Invitations',
      value: data.pendingInvitations,
      icon: Clock,
      variant: 'purple' as const,
      subtitle: 'Your pending responses'
    }
  ];

  return (
    <MetricsGrid>
      {metrics.map((metric) => {
        const IconComponent = metric.icon;
        return (
          <MetricCard
            key={`metric-${metric.label}`}
            icon={<IconComponent size={24} />}
            label={metric.label}
            value={metric.value}
            subtitle={metric.subtitle}
            variant={metric.variant}
            loading={isLoading}
          />
        );
      })}
    </MetricsGrid>
  );
};

export default SchedulerMetrics;
